import { Login } from "./Login";
import { jsx as _jsx } from "react/jsx-runtime";
export function LoginPage() { return /*#__PURE__*/ _jsx(Login, {}); }
